if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const formData = new FormData(this.form);
        const dibuliVariantId = String(formData.get('id'));
        const isDibuliSingle = dibuliVariantId === '57321155789140';
        const isDibuliPack = dibuliVariantId === '57321155821908';
        const characters = ['Conejita', 'Oso', 'Pingüino', 'Gatito'];
        const selectedCharacters = isDibuliSingle
          ? [formData.get('properties[Personaje]')]
          : [formData.get('properties[Personaje 1]'), formData.get('properties[Personaje 2]')];

        if ((isDibuliSingle || isDibuliPack) && !selectedCharacters.every((value) => characters.includes(value))) {
          this.handleErrorMessage(document.documentElement.lang.startsWith('en')
            ? 'Choose the character for each Dibuli before adding it to your cart.'
            : 'Elige el personaje de cada Dibuli antes de añadirlo al carrito.');
          return;
        }

        const quantityInput = document.getElementById('hiddenQuantityInput');
        if (quantityInput) formData.set('quantity', quantityInput.value);

        if (isDibuliSingle || isDibuliPack) {
          // Each add is one complete selection, including two identical characters.
          formData.set('quantity', '1');
          const configurationId = window.crypto && typeof window.crypto.randomUUID === 'function'
            ? window.crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
          formData.set('properties[_dibuli_configuration]', configurationId);
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            const dibuliPack2VariantId = '57321155821908';
            const dibuliGiftVariantId = 57321702130004;

            if (!response.status && String(formData.get('id')) === dibuliPack2VariantId) {
              try {
                const cartState = await fetch('/cart.js').then((r) => r.json());
                const giftAlreadyInCart = cartState.items.some(
                  (item) => Number(item.variant_id) === dibuliGiftVariantId
                );

                if (!giftAlreadyInCart) {
                  const giftPayload = {
                    items: [
                      {
                        id: dibuliGiftVariantId,
                        quantity: 1,
                        properties: { _dibuli_gift: 'true' },
                      },
                    ],
                  };

                  if (this.cart) {
                    giftPayload.sections = this.cart.getSectionsToRender().map((section) => section.id);
                    giftPayload.sections_url = window.location.pathname;
                  }

                  const giftResponse = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      Accept: 'application/json',
                      'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: JSON.stringify(giftPayload),
                  }).then((r) => r.json());

                  if (!giftResponse.status) response = giftResponse;
                }
              } catch (giftError) {
                console.error('Dibuli gift add error:', giftError);
              }
            }

            return response;
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
